import { useEffect, useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSchedules } from "features/Responder/features/Schedules/contexts/SchedulesContext";

const getScheduleIdFromLocation = (location) => {
  const fromState =
    location?.state?.schedule?.id ??
    location?.state?.scheduleId ??
    location?.state?.scheduleID ??
    location?.state?.id ??
    null;
  if (fromState != null) return fromState;
  const params = new URLSearchParams(location?.search || "");
  return params.get("scheduleId") || params.get("schedule_id") || params.get("edit");
};

export const useScheduleHydration = () => {
  const location = useLocation();
  const {
    schedules,
    activeEditSchedule,
    setActiveEditSchedule,
    fetchSchedules,
  } = useSchedules();
  const hydratedRef = useRef(null);

  const locationSchedule = location?.state?.schedule ?? null;
  const scheduleId = getScheduleIdFromLocation(location);

  const scheduleFromList = useMemo(() => {
    if (!scheduleId || !Array.isArray(schedules)) return null;
    return schedules.find((schedule) => `${schedule.id}` === `${scheduleId}`) || null;
  }, [scheduleId, schedules]);

  useEffect(() => {
    if (!locationSchedule && !scheduleId) return;

    const targetSchedule = locationSchedule || scheduleFromList;
    const targetId = targetSchedule?.id ?? scheduleId ?? null;
    if (targetId == null) return;

    if (hydratedRef.current === `${targetId}`) return;

    if (!targetSchedule) {
      if (!Array.isArray(schedules) || schedules.length === 0) {
        fetchSchedules?.();
      }
      return;
    }

    if (`${activeEditSchedule?.id ?? ""}` !== `${targetId}`) {
      setActiveEditSchedule?.(targetSchedule);
    }
    hydratedRef.current = `${targetId}`;
  }, [
    activeEditSchedule,
    fetchSchedules,
    locationSchedule,
    scheduleFromList,
    scheduleId,
    schedules,
    setActiveEditSchedule,
  ]);
};

